import React from 'react';
import {Grid, Header, Card, Loader} from 'semantic-ui-react';
import Workbook from 'vendor/react-excel-workbook';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import REST from 'go/requests/rest';
export class AnalyticsCard extends React.Component {
  constructor(props) {
    super(props);
    this.exportRef = React.createRef();

    this.state = {
      analyticsResults: [],
      assignedCount: 0,
      unassignedCount: 0,
      retrievedFilteredRoles: false,
      loading: false,
    };
  }

  decorators = {
    sortBy: ' ',
    assignee: 'Assigned to',
    phase: 'Phase',
    organizationState: 'Org. State',
    grantId: 'Grant ID ',
    subGrantId: 'Subgrant ID ',
    followUpRequired: 'Flagged for Followup',
    fundingOpportunityNumber: 'Funding Opportunity ',
    name: 'Task',
    created: 'Days in queue',
    createdAfter: 'From Date',
    createdBefore: 'To Date',
    sortOrder: 'Sorted',
    desc: '(descending) by',
    asc: '(ascending) by',
    true: '',
    false: '',
  };

  componentDidMount() {
    REST.workflow
      .getTaskCount(this.props.jwt, this.props.createFetchBodyAssigned())
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        if (resJson) {
          this.setState({assignedCount: resJson.count});
          return resJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });

    REST.workflow
      .getTaskCount(this.props.jwt, this.props.createFetchBodyunAssigned())
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        if (resJson) {
          this.setState({unassignedCount: resJson.count});
          return resJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error('error');
      });
  }

  prepareExport = () => {
    this.setState({
      loading: true,
    });
    const fetchBody = this.props.createFetchBody();

    REST.workflow
      .getTasksWithVariables(
        this.props.jwt,
        fetchBody,
        [
          'organizationState',
          'priorityDisplay',
          'organizationId',
          'organizationName',
          'grantId',
          'subGrantId',
          'fundingOpportunityNumber',
          'followUpRequired',
          'organizationName',
        ],
        1000,
        0
      )
      .then(REST.handler.handleResponse)
      .then((analyticsResults) => {
        const currentAnalyticsResults = this.state.analyticsResults
          ? this.state.analyticsResults
          : [];
        return _.concat(currentAnalyticsResults, analyticsResults);
      })
      .then((analyticsResults) => {
        const userList = _.map(analyticsResults, (result) => result.assignee);
        const filteredUserList = _.filter(userList, function (el) {
          return el != null;
        });
        let userListinput = [...new Set(filteredUserList)];
        const fetchBody = {
          userId: [],
        };
        let count = 0;
        for (var user in userListinput) {
          if (!/\s/.test(userListinput[user])) {
            if (count == 0) {
              fetchBody.userId.push(userListinput[user]);
              count++;
            } else {
              fetchBody.userId.push(userListinput[user]);
            }
          }
        }
        return REST.user
          .getProfilesForUsers(this.props.jwt, fetchBody)
          .then(REST.handler.handleResponse)
          .then((data) => {
            const items = data;
            _.forEach(analyticsResults, (result, index) => {
              _.forEach(items, (i, index) => {
                if (result.assignee === i.userId && i.userId !== undefined) {
                  result.assignee = [i.emailAdr].join(' ');
                  result.assigneeResolved = true;
                }
              });
            });
            return new Promise((resolve) =>
              this.setState(
                {
                  analyticsResults,
                },
                resolve(analyticsResults)
              )
            );
          })
          .then(() => {
            this.triggerExport();
          });
      })
      .catch((error) => {
        console.error('error');
      });
  };

  triggerExport = () => {
    this.exportRef.current.click();
    this.setState({
      loading: false,
    });
  };

  render() {
    const {filtersAsEntered} = this.props;
    const activeFilters = [];

    _.forEach(filtersAsEntered, (value, key) => {
      if (value != '') {
        if (key === 'assignee') {
          value = _.get(
            _.find(this.props.userObjs, (user) => user.userId === value),
            'emailAdr',
            ''
          );
        } else if (key !== 'userId') {
          activeFilters.push(
            `${this.decorators[key] || key} ${this.decorators[value] || value}`
          );
        }
      }
    });

    const WorkloadDashboardDownload = () => {
      const {analyticsResults, loading} = this.state;
      const workloadHMAToggle = _.includes(this.props.toggles, 'workloadHMA');
      let transformedAnalyticsResult = _.cloneDeep(analyticsResults);
      _.forEach(transformedAnalyticsResult, (result, index) => {
        const fundingOppData = _.find(this.props.fundingOpps, (funding) => {
          return funding.fundingOpportunityNr === result.fundingOpportunityNumber;
        });

        const subGrantId = _.get(result, 'subGrantId');
        const grantId = _.get(result, 'grantId');

        _.set(
          transformedAnalyticsResult[index],
          'fundingOpportunityNumber',
          _.get(fundingOppData, 'fundingOpportunityName', result.fundingOpportunityNumber)
        );

        if (workloadHMAToggle)
          _.set(transformedAnalyticsResult[index], 'grantId', subGrantId || grantId);
      });

      return (
        <div>
          {!loading ? (
            <a
              href="#"
              onClick={(e) => {
                if (!this.state.retrievedFilteredRoles) {
                  this.setState(
                    {
                      retrievedFilteredRoles: true,
                    },
                    () => {
                      this.prepareExport();
                    }
                  );
                }
              }}
              title="Workload Dashboard Download"
            >
              Export to Excel
            </a>
          ) : (
            <Loader inline="centered" active>
              Loading...
            </Loader>
          )}
          <Workbook
            filename="WorkloadDashboardDownload.xlsx"
            element={<span ref={this.exportRef}></span>}
          >
            <Workbook.Sheet data={transformedAnalyticsResult} name="Dashboard Sheet">
              <Workbook.Column label="ID" value="grantId" />
              <Workbook.Column label="Organization name" value="organizationName" />
              <Workbook.Column label="State" value="organizationState" />
              <Workbook.Column
                label="Funding opportunity"
                value="fundingOpportunityNumber"
              />
              <Workbook.Column label="Task" value="name" />
              <Workbook.Column label="Priority" value="priorityDisplay" />
              <Workbook.Column label="Flag for follow-up" value="followUpRequired" />
              <Workbook.Column
                label="Days in queue"
                value={(row) => moment().diff(moment(row.created), 'days')}
              />
              <Workbook.Column label="Assigned To" value="assignee" />
            </Workbook.Sheet>
          </Workbook>
        </div>
      );
    };

    return (
      <Card fluid>
        <Card.Content>
          <Grid celled="internally">
            <Grid.Column width={8}>
              <Grid columns={3}>
                <Grid.Column>
                  <Header as="h6">TOTAL TASKS</Header>
                  <Header as="h3">
                    {this.props.filters['assignee'] == null
                      ? this.state.unassignedCount
                      : this.state.assignedCount + this.state.unassignedCount}
                  </Header>
                </Grid.Column>
                <Grid.Column>
                  <Header as="h6">ASSIGNED</Header>
                  <Header as="h3">
                    {this.props.filters['assignee'] == null
                      ? 0
                      : this.state.assignedCount}
                  </Header>
                </Grid.Column>
                <Grid.Column>
                  <Header as="h6">UNASSIGNED</Header>
                  <Header as="h3">{this.state.unassignedCount}</Header>
                </Grid.Column>
              </Grid>
            </Grid.Column>

            <Grid.Column width={6}>
              <Grid.Column>
                <Header as="h6">Active Filters</Header>
                {activeFilters.join(' ')}
              </Grid.Column>
            </Grid.Column>

            <Grid.Column width={2}>
              <Grid.Column textAlign="center">{WorkloadDashboardDownload()}</Grid.Column>
            </Grid.Column>
          </Grid>
        </Card.Content>
      </Card>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    jwt: state.auth.token,
    toggles: _.get(state.toggles, 'toggles'),
  };
};

export default connect(mapStateToProps)(AnalyticsCard);
